import log from '@uwm/logger';

import aemClientService from '@/services/aem/aemClientService';
import type {MarketContentModel} from '@/types/aem';

let content: MarketContentModel = {};

/** A failed fetch is not fatal: the module renders without the authored copy. */
export const initContent = async (marketName: string, languageCode: string) => {
    try {
        content = await aemClientService.initMarketContent<MarketContentModel>(
            marketName?.toLowerCase(),
            languageCode?.toLowerCase()
        );
    } catch (error) {
        content = {};
        log.warn('content: AEM market content unavailable', (error as Error).message);
    }
};

export const getContent = (): MarketContentModel => content;
